import React from "react";
import { Link as ReactLink, makeStyles, LinkProps } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

function Link(props: LinkProps) {
  const classes = useStyles();
  const href = props.href || "";

  // If we can construct a URL that means it's an external link.
  try {
    new URL(href);
    return <ReactLink underline="always" className={classes.root} {...props} />;
    // Otherwise it's an internal site link and we should use RouterLink.
  } catch {
    return (
      <ReactLink
        underline="always"
        component={RouterLink}
        to={href}
        key={href}
        className={classes.root}
        {...props}
      />
    );
  }
}

export default Link;
